/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const createJingleCollectionModelSchema = z.object({
    "name": z.string().max(150).describe("Название подборки"),
"frequency": z.number().int().describe("Частота воспроизведения"),
"startDate": z.string().date().describe("Дата начала"),
"endDate": z.string().date().describe("Дата окончания").nullable().nullish()
    })